// extracted by mini-css-extract-plugin
module.exports = {"rows":"Table_rows__3iOEr","text":"Table_text__1LBhE","large":"Table_large__1DNCB"};